/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import capitalizeString from 'utils/capitalize'
import ActionsMenu from 'features/ActionMenu'
import ApproveIcon from 'assets/icons/approve-user-icon'
import BlockIcon from 'assets/icons/block-icon'
import { SortingArrowWrapper } from 'components/SortingArrow/style'
import { SensitiveSpeciesStatusWrapper, SensitiveSpeciesStatusDot, SensitiveSpeciesStatusText } from './style'

const displayCountry = (countryData, countriesOptions) => {
  if (typeof countryData === 'string' && countryData) {
    return countryData
  }

  if (Array.isArray(countryData) && countryData.length > 0 && countriesOptions && countriesOptions.length > 0) {
    const countryNames = countryData
      .map((countryId) => {
        const country = countriesOptions.find((option) => option.value === countryId)
        return country?.label
      })
      .filter(Boolean)

    if (countryNames.length > 0) {
      return countryNames.length > 2 ? `${countryNames.slice(0, 2).join(', ')}...` : countryNames.join(', ')
    }
  }

  if ((typeof countryData === 'number' || typeof countryData === 'string') && countriesOptions && countriesOptions.length > 0) {
    const country = countriesOptions.find((option) => String(option.value) === String(countryData))
    return country?.label || '-'
  }

  return '-'
}

export const makeSensitiveSitesRows = (
  sites,
  handleApprove,
  handleReject,
  countriesOptions = [],
  actionInProgressId = null
) => {
  return (sites || []).map((item) => {
    const siteHistory = item.SitesHistory || item
    const rowId = item.historyId ?? siteHistory?.id ?? item.id
    const isActionInProgress = actionInProgressId != null && String(rowId) === String(actionInProgressId)

    const proposer = siteHistory?.User || item.proposer || item.User
    const site = siteHistory?.Site || item.Site || item

    const rawStatus =
      item.sensitiveSpeciesVisibilityStatus ??
      item.visibilityStatus ??
      siteHistory?.sensitiveSpeciesVisibilityStatus ??
      siteHistory?.visibilityStatus
    const visibilityApproved =
      item.visibilityApproved ?? item.visibility_approved ?? siteHistory?.visibilityApproved ?? siteHistory?.visibility_approved
    const isApproved =
      rawStatus === 'approved' || rawStatus === 'Approved' || visibilityApproved === true
    const isRejected =
      rawStatus === 'rejected' || rawStatus === 'Rejected' || visibilityApproved === false

    const dropdownItems = []
    if (isApproved) {
      dropdownItems.push({
        icon: <BlockIcon />,
        title: 'sensitiveSpeciesRevoke',
        disabled: isActionInProgress,
        onClick: () => {
          if (isActionInProgress) return
          handleReject(item)
        }
      })
    } else if (isRejected) {
      dropdownItems.push({
        icon: <ApproveIcon />,
        title: 'approve',
        disabled: isActionInProgress,
        onClick: () => {
          if (isActionInProgress) return
          handleApprove(item)
        }
      })
    } else {
      dropdownItems.push(
        {
          icon: <ApproveIcon />,
          title: 'approve',
          disabled: isActionInProgress,
          onClick: () => {
            if (isActionInProgress) return
            handleApprove(item)
          }
        },
        {
          icon: <BlockIcon />,
          title: 'sensitiveSpeciesRejectAction',
          disabled: isActionInProgress,
          onClick: () => {
            if (isActionInProgress) return
            handleReject(item)
          }
        }
      )
    }
    const statusLabel = isApproved
      ? 'sensitiveSpeciesStatusApproved'
      : isRejected
        ? 'sensitiveSpeciesStatusRejected'
        : 'sensitiveSpeciesStatusPending'
    const statusColor = isApproved ? 'rgba(5, 148, 79, 1)' : isRejected ? 'rgba(225, 25, 0, 1)' : 'rgba(255, 193, 7, 1)'

    const rawCountry =
      siteHistory?.country ??
      site?.country ??
      proposer?.country ??
      item.country ??
      siteHistory?.countryId ??
      site?.countryId ??
      proposer?.countryId ??
      item.countryId

    return {
      id: item.id || item.historyId || siteHistory?.id,
      siteCode: site?.siteCode || siteHistory?.siteCode || item.siteCode || '-',
      siteName: siteHistory?.name || site?.name || item.siteName || item.name || '-',
      country: displayCountry(rawCountry, countriesOptions),
      proposerName: proposer
        ? `${capitalizeString(proposer.lastName || '')} ${capitalizeString(proposer.firstName || '')}`
        : '-',
      proposerEmail: proposer?.email || '-',
      visibilityStatus: (
        <SensitiveSpeciesStatusWrapper>
          <SensitiveSpeciesStatusDot color={statusColor} />
          <SensitiveSpeciesStatusText>
            <FormattedMessage id={statusLabel} />
          </SensitiveSpeciesStatusText>
        </SensitiveSpeciesStatusWrapper>
      ),
      action: <ActionsMenu dropdownItems={dropdownItems} />
    }
  })
}

export const makeSensitiveSitesColumns = (sorting, setSorting) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteCode = () => {
    sortFunction('siteCode')
  }

  const sortBySiteName = () => {
    sortFunction('siteName')
  }

  const sortByProposerName = () => {
    sortFunction('proposerName')
  }

  const sortByProposerEmail = () => {
    sortFunction('proposerEmail')
  }

  const sortByCountry = () => {
    sortFunction('country')
  }

  const sortByVisibilityStatus = () => {
    sortFunction('visibilityStatus')
  }
  return [
    {
      id: 'siteCode',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="siteCode" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'siteCode'}
              onChange={sortBySiteCode}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="siteNameInternational" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'siteName'}
              onChange={sortBySiteName}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="country" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'country'}
              onChange={sortByCountry}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'proposerName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="proposerName" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'proposerName'}
              onChange={sortByProposerName}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'proposerName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'proposerEmail',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="proposerEmail" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'proposerEmail'}
              onChange={sortByProposerEmail}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'proposerEmail',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'visibilityStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id="sensitiveSpeciesVisibilityStatus" />
          {
            <SortingArrow
              checked={sorting.sortDirection === sortDirection.ASC && sorting.sortBy === 'visibilityStatus'}
              onChange={sortByVisibilityStatus}
            />
          }
        </SortingArrowWrapper>
      ),
      accessorKey: 'visibilityStatus',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'action',
      header: <FormattedMessage id="actions" />,
      accessorKey: 'action',
      cell: ({ getValue }) => getValue()
    }
  ]
}
